class MobileSearchController {
  constructor() {
    this.name = 'mobileSearch';
  }
}

export default MobileSearchController;
